import styled, { css } from "styled-components"

export default {
    "ContactInputDiv": styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 8px;
        width: 100%;

        & > h2 {
            ${({ theme }) => theme.font["large-semibold"]};

            span {
                color: ${({ theme }) => theme.color["error"]};
            }
        }
    `,
    "ContactInputForm": styled.div`
        width: 100%;
        display: flex;
        gap: 8px;
        height: 36px;

        & > input {
            width: 100%;
            padding: 12px;
            border-radius: 4px;
            border: 1px solid ${({ theme }) => theme.color["grey3"]};
            color: ${({ theme }) => theme.color["black"]};
            ${({ theme }) => theme.font["large-medium"]};
        }

        & > button {
            padding: 8px;
            border-radius: 4px;
            border: 1px solid ${({ theme }) => theme.color["grey3"]};
            color: ${({ theme }) => theme.color["white"]};
            background-color: ${({ theme }) => theme.color["black"]};
            ${({ theme }) => theme.font["medium-medium"]};

            ${({ $deactive }) => $deactive && css`
                color: ${({ theme }) => theme.color["grey4"]};
                background-color: ${({ theme }) => theme.color["grey2"]};
                cursor: not-allowed;
            `}
        }
    `,
    "option": styled.p`
        ${({ theme }) => theme.font["small-semibold"]};
        color: ${({ theme }) => theme.color["blue"]};
    `,
    "hint": styled.p`
        ${({ theme }) => theme.font["small-medium"]};
        color: ${({ theme }) => theme.color["grey3"]};
    `,
}